<template>
  <div class="cmp-upload-container">
    <template v-if="type == 'image'">
      <cmp-upload-image class="isInline" :files="files" :is-view-only="isViewOnly" @on-file-remove="handleRemove">
        <Poptip :content="fileTip()" trigger="hover" transfer word-wrap :width="300">
          <file-upload :input-id="name" :name="name" ref="upload" v-model="files" :headers="headerConfig" :post-action="postAction" @input-file="inputFile" @input-filter="inputFilter" :accept="acceptConfig" :multiple="multiple" :chunk-enabled="chunkEnabled" :chunk="chunkConfig">
            <div style="height: 120px" v-if="!isViewOnly">
              <div class="upload-image">
                <Icon :type="imgIcon" size="52"></Icon>
                <p>{{ uploadImagesLabel }}</p>
              </div>
            </div>
          </file-upload>
        </Poptip>
      </cmp-upload-image>
      <div v-if="!isViewOnly" class="red">{{ fileTip() }}</div>
      <div v-if="!isViewOnly" class="red">{{ annotation }}</div>
    </template>
    <!-- <div class="cmp-upload-start isInline"></div> -->
    <template v-if="type == 'list'">
      <Poptip v-if="!isViewOnly" :content="fileTip()" trigger="hover" transfer word-wrap :width="300">
        <file-upload v-if="!isViewOnly" :input-id="name" :name="name" ref="upload" v-model="files" :headers="headerConfig" :post-action="postAction" @input-file="inputFile" @input-filter="inputFilter" :accept="acceptConfig" :multiple="multiple" :chunk-enabled="chunkEnabled" :chunk="chunkConfig">
          <Button type="primary" icon="ios-cloud-upload-outline">{{ uploadFilesLabel }}</Button>
        </file-upload>
      </Poptip>
      <div v-if="!isViewOnly" class="red">{{ fileTip() }}</div>
      <div v-if="!isViewOnly" class="red">{{ annotation }}</div>
      <cmp-upload-list :files="files" :is-view-only="isViewOnly" @on-file-remove="handleRemove" @on-file-preview="handlePreview"></cmp-upload-list>
    </template>
    <slot></slot>
  </div>
</template>

<script>
import fileUpload from "vue-upload-component";
import CmpUploadList from "./cmp-upload-list";
import CmpUploadImage from "./cmp-upload-image";
import { appConst, $util } from "@/lib";
import base from "@/lib/utils/types/base";

const fileAccept = {
  image: "image/*",
  list: "application/*",
};
export default {
  name: "cmp-upload",
  components: { CmpUploadImage, CmpUploadList, fileUpload },
  props: {
    name: {
      type: String,
    },
    type: {
      type: String,
      validator(value) {
        return $util.oneOf(value, ["list", "image"]);
      },
      default: "list",
    },
    chunkEnabled: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    accept: {
      type: String,
    },
    format: {
      type: Array,
      default() {
        return [];
      },
    },
    maxSize: {
      type: Number,
      default: 20,
    },
    maxNum: {
      type: Number,
      default: 4,
    },
    imgIcon: {
      type: String,
      default: "ios-add",
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    uploadAuto: {
      type: Boolean,
      default: true,
    },
    isViewOnly: {
      type: Boolean,
      default: false,
    },
    annotation: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // fileTip:
      //   "文件类型必须是" +
      //   this.fileFormat.join(",") +
      //   "中的一种且不能大于" +
      //   this.maxSize +
      //   "M",
      files: [],
      num: 0,
      postAction: appConst.appBaseUrl + appConst.uploadUrl.postAction,
      headerConfig: {
        Authorization: "Bearer " + window.basic.utils.getToken(),
        "Abp.TenantId": window.basic.utils.getTenantIdCookie(),
      },
      chunkConfig: {
        action: appConst.appBaseUrl + appConst.uploadUrl.postAction,
        minSize: 1024 * 1024 * 20,
        maxActive: "3",
        maxRetries: "5",
        headers: {
          Authorization: "Bearer " + window.basic.utils.getToken(),
          "Abp.TenantId": window.basic.utils.getTenantIdCookie(),
        },
      },
      acceptConfig: fileAccept[this.type],
      uploadImagesLabel: base.L("Upload.UploadImages"),
      uploadFilesLabel: base.L("Upload.UploadFiles"),
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(fileList) {
        // console.log("upload>>>>", fileList, this.files);
        if (this.files.length != fileList.length || !this.files.every(x=>fileList.some(p=>x.fileId === p.fileId))) {
          this.num = fileList.length;
          this.files = fileList.map((item) => {
            let mapItem = {
              name: item.uploadFileName,
              fileId: item.fileId,
              progress: "0.00",
              url: appConst.appBaseUrl + appConst.uploadUrl.previewAction + "?id=" + item.fileId,
              active: false,
              success: true,
            };
            return mapItem;
          });
          }
      },
    },
    files: {
      handler() {
        if (
          !this.files.some((item) => {
            return !item.success;
          })
        )
          this.$emit(
            "input",
            this.files.map((item) => {
              return { fileId: item.fileId, uploadFileName: item.name };
            })
          );
      },
    },
    accept: {
      immediate: true,
      handler(acceptValue) {
        if (acceptValue != "") {
          this.acceptConfig = acceptValue;
        }
      },
    },
  },
  methods: {
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // 添加文件前
        //check maxNum
        if (this.multiple) {
          this.num++;
          if (this.num > this.maxNum) {
            this.num--;
            this.$Message.warning(base.L("Upload.UploadMAX") + " " + this.maxNum + " " + base.L("Upload.Documents"));
            return prevent();
          }
        }
        let fileFormat = this.fileFormat();
        //check type
        if (fileFormat && fileFormat.length > 0) {
          const format = fileFormat.join(",");
          const _file_format = newFile.name.split(".").pop().toLocaleLowerCase();
          const checked = fileFormat.some((item) => item.toLocaleLowerCase() === _file_format);
          if (!checked) {
            this.num--;
            this.$Message.warning({
              content: base.L("Upload.FileType") + " " + format,
              duration: 3,
            });
            return prevent();
          }
        }

        // check maxSize
        if (this.maxSize) {
          if (newFile.size > this.maxSize * 1024 * 1024) {
            this.num--;
            this.$Message.warning({
              content: base.L("Upload.FileSize") + " " + this.maxSize + "M",
              duration: 3,
            });
            return prevent();
          }
        }

        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
      if (this.type === "image" && newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }

        // Thumbnails
        // 缩略图
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
    },

    inputFile(newFile, oldFile) {
      if (newFile && !newFile.active && newFile.error && newFile.error != "") {
        this.$Message.error(base.L("Upload.Fail"));
      }
      //console.log(newFile, "newfile");
      //console.log("success2", this.files);
      if (newFile && !oldFile) {
        // add
        //console.log("add", newFile);
      }
      if (newFile && oldFile) {
        // update
        //console.log("update", newFile);
      }

      if (!newFile && oldFile) {
        // remove
        // this.num--;
        //console.log("remove", oldFile);
      }

      if (newFile && oldFile && !newFile.active && newFile.success && oldFile.active) {
        let data = {
          name: newFile.name,
          id: newFile.id,
          fileId: newFile.response.id,
          success: true,
          active: false,
          progress: "0.00",
        };
        if (this.type == "image") {
          Object.assign(data, { thumb: newFile.thumb });
        }
        //上传完成
        Object.assign(newFile.response, { data: data });

        // newFile.response.data.name = newFile.name;
        // newFile.response.data.id = newFile.id;
        // newFile.response.data.success = true;
        // newFile.response.data.active = false;
        // newFile.response.data.progress = "0.00";
        this.files.push(newFile.response.data); // 把 uploader 里的文件赋值给 value
        this.$refs.upload.remove(newFile); // 删除当前文件对象
        //console.log("success", this.files);
        this.$emit("upload-success", this.files);
      }

      // Automatically activate upload
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (this.uploadAuto && !this.$refs.upload.active) {
          this.$refs.upload.active = true;
        }
      }
    },

    handleRemove({ file, index }) {
      //console.log(file);
      this.files.splice(index, 1);
      this.num--;
      if (file.success && file.fileId) {
        this.$store.dispatch({
          type: "system/attachment/deleteFile",
          data: { id: file.fileId },
        });

        this.$emit("remove-success", this.files);
      }

      //console.log("RemoveSuccess", this.files);
    },

    //文件预览
    async handlePreview(file) {
      if (file.success && file.fileId) {
        //下载文件
        let response = await this.$store.dispatch({
          type: "system/attachment/preViewFile",
          data: { id: file.fileId },
        });
        let name = response.headers["content-disposition"].split("=")[1];

        this.$util.downloadFile(response.data, decodeURI(name));
      }
    },

    fileFormat() {
      if (this.format.length > 0) {
        return this.format;
      } else if (this.type == "list") {
        return ["jpg", "jpeg", "gif", "png", "7z", "rar", "zip", "swf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "pdf", "txt"];
      } else {
        return ["jpg", "jpeg", "gif", "png"];
      }
    },

    fileTip() {
      let fileFormat = this.fileFormat();
      return base.L("Upload.Tips", fileFormat.join("，"));
    },
  },
  computed: {},
};
</script>
<style lang="stylus">
.file-uploads.file-uploads-html4 input, .file-uploads.file-uploads-html5 label {
  cursor: pointer !important;
}
</style>
<style scoped lang="stylus">
.isInline {
  display: inline-block;
}

.bottom-12 {
  position: relative;
  bottom: 12px;
}

.upload-image {
  display: inline-block;
  width: 120px;
  height: 120px;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  border: 1px #ddd dashed;
  padding: 20px;

  i {
    color: $theme-color;
    width: 100%;
    text-align: center;
  }

  p {
    width: 100%;
    text-align: center;
    color: $theme-color;
  }
}
.red{
  color:red;
  font-size:12px;
  line-height:20px;
}
</style>
